import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useAtom, useAtomValue } from 'jotai';

import { BuildingOfficeIcon, ChevronLeftIcon } from '@heroicons/react/24/outline';
import { Heading, Button } from '@restworld/ui-ds-base';

import { companyProfileAtom, fullRatingAtom, fullViewAtom } from '../../job-position/job-position.atoms';

import { cn } from '@restworld/utils-common';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICompanyProfileHeaderProps {}
export const CompanyProfileHeader: React.FunctionComponent<ICompanyProfileHeaderProps> = () => {
  const { restaurantName } = useAtomValue(companyProfileAtom);
  const [fullView, setFullView] = useAtom(fullViewAtom);
  const [fullRating, setFullRating] = useAtom(fullRatingAtom);

  const { t } = useTranslation('common');

  const clickHandler = React.useCallback(() => {
    setFullView(false);
    setFullRating(false);
  }, [setFullRating, setFullView]);

  return (
    <>
      <span className="flex flex-row items-center gap-1.5 justify-center">
        <BuildingOfficeIcon className="h-5 text-primary-800" />
        <Heading align="center">{t('company')}</Heading>
      </span>
      <StoreTitleWrapper>
        {(fullView || fullRating) && <Button StartIcon={ChevronLeftIcon} onClick={clickHandler} variant="ghost" />}
        {restaurantName && (
          <Heading weight="medium" align="center">
            {restaurantName}
          </Heading>
        )}
      </StoreTitleWrapper>
    </>
  );
};
export default CompanyProfileHeader;
const StoreTitleWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex justify-center gap-4', className)} {...props} />
);
